import { render, staticRenderFns } from "./RoleCreate.vue?vue&type=template&id=76999774&scoped=true&"
import script from "./RoleCreate.vue?vue&type=script&lang=js&"
export * from "./RoleCreate.vue?vue&type=script&lang=js&"
import style0 from "./RoleCreate.vue?vue&type=style&index=0&id=76999774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76999774",
  null
  
)

export default component.exports